import { Star } from 'lucide-react';
import clsx from 'clsx';

export default function StarRating({ rating = 0, size = 14, showValue = true, reviewsCount, className }) {
  return (
    <div className={clsx('flex items-center gap-1', className)}>
      <div className="flex items-center">
        {[1, 2, 3, 4, 5].map((n) => (
          <Star
            key={n}
            size={size}
            className={n <= Math.round(rating) ? 'fill-warning text-warning' : 'fill-slate-200 text-slate-200 dark:fill-slate-700 dark:text-slate-700'}
          />
        ))}
      </div>
      {showValue && (
        <span className="text-xs font-medium text-slate-500 dark:text-slate-400">
          {rating.toFixed(1)}
          {reviewsCount !== undefined && ` (${reviewsCount.toLocaleString('en-IN')})`}
        </span>
      )}
    </div>
  );
}
